// A console page for a member whose home is the chat app (ADR-20260930 D7):
// auth-service names the home on GET /session, and the console forwards
// there with a history replace, so Back does not return to the console. A
// short line shows while the browser leaves.
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function HomeForward({ to }: { to: string }) {
  const { t } = useTranslation('admin')
  useEffect(() => {
    window.location.replace(to)
  }, [to])
  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--background)] px-6" data-testid="home-forward">
      <p role="status" className="m-0 text-sm text-text-muted">{t('guestNotice.forwarding')}</p>
    </main>
  )
}
